import { lazy, Suspense } from 'react';
import { Navigate, redirect, RouteObject } from 'react-router-dom';
import LoadingCircularProgress from '~/components/LoadingCircularProgress';
import { PriceMonitoringRouteEnum, RootRouteEnum } from '~/router/@types';
import { PermissionMap } from '~/router/permissionMap';

const MonitoringWrapper = lazy(() => import('~/pages/PriceMonitoring/MonitoringWrapper'));
const PriceAnalytics = lazy(() => import('~/pages/PriceMonitoring/Analytics'));

export const PRICE_MONITORING_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={PriceMonitoringRouteEnum.Monitoring} replace />,
  },
  {
    path: PriceMonitoringRouteEnum.Analytics,
    loader: async () => {
      const hasAccess = await PermissionMap.PriceMonitoring();
      if (hasAccess) {
        return null; // bypass
      } else {
        return redirect(`/${RootRouteEnum.Home}`);
      }
    },
    children: [
      {
        path: ':model_id?',
        element: (
          <Suspense fallback={<LoadingCircularProgress open />}>
            <PriceAnalytics />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: PriceMonitoringRouteEnum.Monitoring,
    children: [
      {
        path: ':model_id?/:country?',
        element: (
          <Suspense fallback={<LoadingCircularProgress open />}>
            <MonitoringWrapper />
          </Suspense>
        ),
      },
    ],
  },

  {
    path: '*',
    loader: async ({ params, request }) => {
      const url = new URL(request.url);
      const queryString = url.search;
      const paramPath = Object.values(params).join('/');
      return redirect(`${PriceMonitoringRouteEnum.Monitoring}/${paramPath}${queryString}`);
    },
  },
];
